import src from "IMAGE";
export default { src, width: 203, height: 144, blurWidth: 0, blurHeight: 0};
